export const environment = {
  production: false,
  apiUrl: 'https://localhost:7134/api/v1',
  comuniApiUrl: 'https://axqvoqvbfjpaamphztgd.functions.supabase.co'
};

